<template>
  <div
    v-if="initialised"
    class="row"
    :class="
      $can('read', 'availabilities', 'scrutiny-lock')
        ? 'advanced-filter'
        : 'advanced-filter-no-scrutiny'
    "
  >
    <div class="col-12">
      <div class="input-group">
        <template v-if="dateRange">
          <div class="date-from mr-3">
            <el-date-picker
              v-model="from"
              :placeholder="$lodash.get(dateRange, 'fromPlaceholder', 'Date from')"
              format="dd MMM yyyy"
              @change="changeFrom"
            />
          </div>

          <div class="date-to mr-3">
            <el-date-picker
              v-model="to"
              :placeholder="$lodash.get(dateRange, 'toPlaceholder', 'Date to')"
              format="dd MMM yyyy"
              @change="changeTo"
            />
          </div>
        </template>

        <template v-if="selectFilters">
          <select
            v-for="(config, name) in selectFilters"
            :key="name"
            v-model="selectFilterValues[name]"
            :name="name"
            class="form-control mr-3 bordered"
            @change="updateSelects(name, $event.target.value)"
          >
            <option disabled="disabled" value="">Filter by {{ name.replace(/_/g, " ") }}</option>
            <option v-if="config.allConfig" :value="config.allConfig.value">
              {{ config.allConfig.label }}
            </option>
            <option v-else value="">All</option>
            <option v-for="(option, index) in config.options" :key="index" :value="option['value']">
              {{ option["label"] }}
            </option>
          </select>
        </template>

        <button class="btn btn-secondary" style="margin-top: -2.5px" @click.prevent="reset">
          <font-awesome-icon :icon="['fal', 'undo']" />
        </button>

        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
import moment from "moment";
import clone from "lodash/clone";
import EventBus from "../../imports/event-bus";

export default {
  name: "AdvancedFilter",
  props: {
    selectFilters: {
      type: Object,
    },
    dateRange: {
      type: Boolean,
    },
    afterChange: {
      type: Function,
    },
    refs: {
      type: Object,
    },
  },
  data() {
    return {
      from: "",
      to: "",
      initialised: false,

      initialSelectFilterValues: {},
      selectFilterValues: {},
    };
  },

  unmounted() {
    this.clear();
  },

  mounted() {
    this.clear();

    EventBus.$on("reset-advanced-filter", () => {
      this.reset();
    });

    this.init();

    this.from = this.$store.state["advanced-filter"].from;
    this.to = this.$store.state["advanced-filter"].to;
  },

  methods: {
    init() {
      if (this.selectFilters) {
        Object.keys(this.selectFilters).forEach((name) => {
          this.selectFilterValues[name] = this.$lodash.get(
            this.selectFilters,
            `[${name}].value`,
            ""
          );
        });

        this.initialSelectFilterValues = clone(this.selectFilterValues);
        this.$store.state["advanced-filter"].selectFilters = this.selectFilterValues;
      }

      this.initialised = true;
      this.$emit("ready");
    },

    changeFrom(value) {
      const date = value === null ? null : moment(value).format("YYYY-MM-DD");

      this.from = date;
      this.$store.state["advanced-filter"].from = date;
      this.refs.table.serverSearch();
    },

    changeTo(value) {
      const date = value === null ? null : moment(value).format("YYYY-MM-DD");

      this.to = date;
      this.$store.state["advanced-filter"].to = date;
      this.refs.table.serverSearch();
    },

    updateSelects(name, value) {
      this.selectFilterValues[name] = value;
      this.$store.state["advanced-filter"].selectFilters = this.selectFilterValues;

      this.$emit("change", {
        name,
        value,
      });

      if (this.afterChange) {
        this.afterChange(name, value, this.selectFilterValues);
      }

      this.refs.table.serverSearch();
    },

    clear() {
      this.$store.state["advanced-filter"].from = "";
      this.$store.state["advanced-filter"].to = "";
      this.$store.state["advanced-filter"].selectFilters = clone(this.initialSelectFilterValues);
      this.from = "";
      this.to = "";
      this.selectFilterValues = clone(this.initialSelectFilterValues);
    },

    reset() {
      this.clear();

      Object.keys(this.selectFilterValues).forEach((name) => {
        this.$emit("change", {
          name,
          value: this.selectFilterValues[name],
        });
      });
      this.$forceUpdate();

      this.$nextTick(() => {
        if (this.refs && this.refs.table) {
          this.refs.table.query = "";
          this.refs.table.refresh();
        }
      });
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.advanced-filter {
  position: relative;
  z-index: 1;
  top: 2.5px;
  margin-left: 187px;
  margin-bottom: -35px;
}

.advanced-filter-no-scrutiny {
  position: relative;
  z-index: 1;
  margin-left: 187px;
  margin-bottom: -35px;
}

::v-deep input {
  width: 165px;
  height: 35px !important;
  flex: none;
}

select.form-control {
  width: 165px;
  height: 35px !important;
  flex: none;
  flex-direction: row;
}

.extra {
  margin-right: 8px;
}
</style>
